import { render, staticRenderFns } from "./PvApplicationList.vue?vue&type=template&id=641394ea"
import script from "./PvApplicationList.vue?vue&type=script&lang=js"
export * from "./PvApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports